(function(){
  var bar=document.querySelector('.icl-guide .icl-sticky');
  if(!bar)return;
  var start=document.querySelector(bar.getAttribute('data-after'));
  var end=document.querySelector('.icl-guide .icl-close');
  if(!start)return;
  var ticking=false;
  function paint(){
    ticking=false;
    var vh=window.innerHeight||document.documentElement.clientHeight;
    var on=start.getBoundingClientRect().top<0&&!(end&&end.getBoundingClientRect().top<vh);
    bar.classList.toggle('is-on',on);
    bar.setAttribute('aria-hidden',on?'false':'true');
    var a=bar.querySelector('a');if(a)a.tabIndex=on?0:-1;
  }
  window.addEventListener('scroll',function(){if(!ticking){ticking=true;requestAnimationFrame(paint);}},{passive:true});
  paint();
})();

(function(){
  var vids=document.querySelectorAll('.icl-guide .icl-media video');
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  Array.prototype.forEach.call(vids,function(v){
    if(reduce){v.removeAttribute('autoplay');v.pause();v.setAttribute('controls','');}
    if(!v.hasAttribute('controls')){v.addEventListener('click',function(){if(v.paused){v.play();}else{v.pause();}});v.style.cursor='pointer';v.setAttribute('title','Tap to pause or play');}
  });
})();

/* ---------- buy boxes (one or more per page) + shared drawers + expert drawer ---------- */
(function(){
  var els=Array.prototype.slice.call(document.querySelectorAll('.icl-guide .icl-buy'));
  if(!els.length)return;
  function qa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));}
  function parse(el,sel){try{return JSON.parse(el.querySelector(sel).textContent)||{};}catch(e){return {};}}
  var cfg=parse(els[0],'.icl-buy__cfg');
  var cc=(cfg.country||'NZ').toUpperCase();

  /* dates: 3-5 business days from today, in the dispatch warehouse's time zone */
  var DAY=['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],MON=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var hol=(cfg.holidays&&cfg.holidays[cc==='AU'?'AU':'NZ'])||[];
  function today(){
    var tz=cc==='AU'?'Australia/Melbourne':'Pacific/Auckland',s;
    try{s=new Intl.DateTimeFormat('en-CA',{timeZone:tz,year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());}catch(e){s='';}
    var m=/(\d{4})-(\d{2})-(\d{2})/.exec(s);var d=new Date();
    return m?new Date(Date.UTC(+m[1],+m[2]-1,+m[3])):new Date(Date.UTC(d.getFullYear(),d.getMonth(),d.getDate()));
  }
  function iso(d){return d.toISOString().slice(0,10);}
  function addBiz(d,n){var x=new Date(d.getTime());while(n>0){x.setUTCDate(x.getUTCDate()+1);var w=x.getUTCDay();if(w!==0&&w!==6&&hol.indexOf(iso(x))<0)n--;}return x;}
  function fmt(d){return DAY[d.getUTCDay()]+' '+d.getUTCDate()+' '+MON[d.getUTCMonth()];}
  var t0=today(),dMin=addBiz(t0,3),dMax=addBiz(t0,5);
  var dispatchTxt='Estimated dispatch: '+fmt(dMin)+' – '+fmt(dMax);

  var boxes=[],active=null,expertDr=document.getElementById('icx-expert-drawer');
  function entry(b){var s=b.m[b.size]||{};return s[b.colour]||null;}
  function anyEntry(b,size){var s=b.m[size]||{};for(var k in s){if(s[k])return true;}return false;}
  function sizeBtn(b,size){return b.sizes.filter(function(x){return x.getAttribute('data-size')===size;})[0];}
  function setExpert(b){
    var e=entry(b),d=sizeBtn(b,b.size);if(!expertDr||!e)return;
    var img=expertDr.querySelector('.icx-expert-card__img');if(img&&e.image)img.src=e.image;
    var ti=expertDr.querySelector('.icx-expert-card__title');if(ti)ti.textContent=e.title;
    var pr=expertDr.querySelector('.icx-expert-card__amt');if(pr)pr.textContent=e.price;
    var set=function(n,v){var i=expertDr.querySelector('input[name="contact['+n+']"]');if(i)i.value=v;};
    set('product',e.title);set('enquiry_type','Expert consultation (guide page) — '+e.title);
    try{set('product_url',new URL(e.url,location.href).href);}catch(x){}
  }
  /* section photo tied to a box: follows its colour and size (swapped once the new photo has loaded) */
  function wq(u,n){return u.replace(/([?&])width=\d+/,'$1width='+n);}
  function srcset(u){return [600,1000,1400].map(function(n){return wq(u,n)+' '+n+'w';}).join(', ');}
  function fillT(t,b,d){return (t||'').replace('{label}',d.label).replace('{name}',d.name).replace('{colour}',b.colourName||'');}
  function photo(b){return document.querySelector('.icl-guide [data-box-image="'+b.id+'"]');}
  function prefetch(b,size,colour){
    var e=(b.m[size]||{})[colour],f=photo(b);if(!e||!e.shot||!f||f.getAttribute('data-shot')===e.shot)return;
    var img=f.querySelector('img'),pre=new Image();pre.sizes=img?img.sizes:'100vw';pre.srcset=srcset(e.shot);pre.src=wq(e.shot,1200);
  }
  function setPhoto(b,e,d){
    var f=photo(b);if(!f||!e||!e.shot)return;
    var img=f.querySelector('img');if(!img)return;
    var cap=document.querySelector('.icl-guide [data-box-caption="'+b.id+'"]');
    var alt=fillT(f.getAttribute('data-alt'),b,d),capT=fillT(f.getAttribute('data-cap'),b,d);
    if(!f.hasAttribute('data-shot')){f.setAttribute('data-shot',e.shot);return;}
    if(f.getAttribute('data-shot')===e.shot){img.alt=alt;if(cap)cap.textContent=capT;return;}
    f.setAttribute('data-shot',e.shot);f.classList.add('is-loading');
    var ss=srcset(e.shot),pre=new Image();pre.sizes=img.sizes;pre.srcset=ss;pre.src=wq(e.shot,1200);
    var done=function(){if(f.getAttribute('data-shot')!==e.shot)return;
      img.srcset=ss;img.src=wq(e.shot,1200);img.alt=alt;if(cap)cap.textContent=capT;f.classList.remove('is-loading');};
    if(pre.decode)pre.decode().then(done,done);else{pre.onload=pre.onerror=done;}
  }
  function render(b,focusEl){
    var e=entry(b),d=sizeBtn(b,b.size).dataset,cname=b.colourName||'';
    setPhoto(b,e,d);
    b.q('.icl-buy__name').textContent=d.name;
    b.q('.icl-buy__price').textContent=e?e.price:'';
    b.q('.icl-buy__finish').textContent=(b.el.getAttribute('data-finish')||'').replace('{colour}',cname);
    b.q('.icl-buy__chosen').textContent=d.label+' · Cooks for '+d.cooks;
    var cc2=b.q('.icl-buy__chosencolour');if(cc2)cc2.textContent='Colour: '+cname;
    b.q('.icl-buy__fit').textContent=d.fit;
    var sold=!e||e.available===false;
    var cta=b.q('.icl-buy__cta');if(e)cta.href=e.url;
    cta.textContent=(sold?'Sold out · See the ':'Shop the ')+d.label+' '+d.name;
    cta.setAttribute('data-cta',(b.el.getAttribute('data-cta-base')||'buy')+'-'+b.size+(b.colours.length?'-'+b.colour:''));
    b.sizes.forEach(function(x){var s=x.getAttribute('data-size'),on=s===b.size,xe=(b.m[s]||{})[b.colour];
      x.setAttribute('aria-checked',on?'true':'false');x.tabIndex=on?0:-1;
      x.hidden=!anyEntry(b,s);x.classList.toggle('is-soldout',!xe||xe.available===false);});
    b.colours.forEach(function(x){var c=x.getAttribute('data-colour'),on=c===b.colour,xe=(b.m[b.size]||{})[c];
      x.setAttribute('aria-checked',on?'true':'false');x.tabIndex=on?0:-1;x.classList.toggle('is-soldout',!xe||xe.available===false);});
    qa('[data-for]',b.el).forEach(function(el){el.hidden=el.getAttribute('data-for')!==b.size;});
    if(b.sticky){var st=document.querySelector('.icl-guide .icl-sticky');
      if(st&&e){var l=st.querySelector('.icl-sticky__label');if(l)l.textContent=d.name+' · '+e.price;var a=st.querySelector('a');if(a)a.href=e.url;}}
    if(active===b)setExpert(b);
    var out=document.querySelector('.icl-pc__out');
    if(out&&out.getAttribute('data-key')&&out.getAttribute('data-key').indexOf(b.id+':')===0&&out.getAttribute('data-key')!==b.id+':'+b.size+':'+b.colour){out.innerHTML='';out.removeAttribute('data-key');if(b.sub)b.sub.textContent=dispatchTxt;}
    if(focusEl)focusEl.focus();
  }
  els.forEach(function(el){
    var b={el:el,id:el.getAttribute('data-box')||'buy',m:parse(el,'.icl-buy__matrix'),sticky:el.hasAttribute('data-sticky')};
    b.q=function(s){return el.querySelector(s);};
    b.sizes=qa('.icl-buy__size',el);b.colours=qa('.icl-buy__colour',el);
    b.size=el.getAttribute('data-default-size')||(b.sizes[0]&&b.sizes[0].getAttribute('data-size'));
    b.colour=el.getAttribute('data-default-colour')||'default';
    var cb=b.colours.filter(function(x){return x.getAttribute('data-colour')===b.colour;})[0];b.colourName=cb?cb.getAttribute('data-colour-name'):'';
    b.sub=b.q('[data-dispatch]');if(b.sub)b.sub.textContent=dispatchTxt;
    function wire(list,attr,setter){list.forEach(function(x,i){
      x.addEventListener('click',function(){setter(x);active=b;render(b);});
      var pf=function(){if(attr==='data-size')prefetch(b,x.getAttribute('data-size'),b.colour);else prefetch(b,b.size,x.getAttribute('data-colour'));};
      x.addEventListener('pointerenter',pf);x.addEventListener('touchstart',pf,{passive:true});x.addEventListener('focus',pf);
      x.addEventListener('keydown',function(ev){var j=null;
        if(ev.key==='ArrowRight'||ev.key==='ArrowDown')j=(i+1)%list.length;
        if(ev.key==='ArrowLeft'||ev.key==='ArrowUp')j=(i-1+list.length)%list.length;
        if(j!==null){ev.preventDefault();setter(list[j]);render(b,list[j]);}});});}
    wire(b.sizes,'data-size',function(x){b.size=x.getAttribute('data-size');});
    wire(b.colours,'data-colour',function(x){b.colour=x.getAttribute('data-colour');b.colourName=x.getAttribute('data-colour-name');});
    var more=b.q('.icl-buy__more');
    if(more)more.addEventListener('click',function(){var open=more.getAttribute('aria-expanded')==='true';
      more.setAttribute('aria-expanded',open?'false':'true');el.classList.toggle('is-more',!open);
      b.q('.icl-buy__plus').textContent=open?'+':'–';more.lastElementChild.textContent=open?'Show more':'Show less';});
    qa('[data-open]',el).forEach(function(x){x.addEventListener('click',function(){active=b;openD(x.getAttribute('data-open'),x);});});
    var t=b.q('.icx-expert__trigger');if(t)t.addEventListener('click',function(){active=b;setExpert(b);});
    boxes.push(b);
  });
  active=boxes[0];
  boxes.forEach(function(b){render(b);});

  /* drawers: move to <body> so theme stacking contexts can't trap them */
  var overlay=null,last=null;
  qa('.icl-guide .icl-drawers').forEach(function(w){qa('.icl-drawer',w).forEach(function(d){document.body.appendChild(d);});
    var o=w.querySelector('.icl-overlay');if(o){document.body.appendChild(o);overlay=o;}});
  function openD(id,from){var d=document.getElementById(id);if(!d)return;closeD();last=from||null;
    d.classList.add('is-open');d.setAttribute('aria-hidden','false');if(overlay)overlay.classList.add('is-open');
    document.documentElement.style.overflow='hidden';
    setTimeout(function(){var f=d.querySelector('input:not([type="hidden"])')||d;f.focus();},350);}
  function closeD(){var o=document.querySelector('.icl-drawer.is-open');if(!o)return;o.classList.remove('is-open');o.setAttribute('aria-hidden','true');
    if(overlay)overlay.classList.remove('is-open');document.documentElement.style.overflow='';if(last){last.focus();last=null;}}
  qa('.icl-drawer__close').forEach(function(x){x.addEventListener('click',closeD);});
  if(overlay)overlay.addEventListener('click',closeD);
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeD();});
  qa('.icl-drawer__pick').forEach(function(x){x.addEventListener('click',function(){
    var b=boxes.filter(function(bb){return bb.id===x.getAttribute('data-box');})[0]||boxes[0];
    b.size=x.getAttribute('data-pick');active=b;closeD();render(b,sizeBtn(b,b.size));});});

  /* gift: the store's Giftnote button; fall back to a line of text if the app isn't loaded */
  var gn=document.querySelector('.icl-drawer giftnote-button'),fb=document.querySelector('.icl-gn-fallback');
  if(gn&&fb)setTimeout(function(){if(!(window.customElements&&customElements.get('giftnote-button'))){gn.style.display='none';fb.hidden=false;}},2500);

  /* delivery: live rate for the selected pan and postcode, straight from Shopify (Storefront API, no token needed) */
  var form=document.querySelector('.icl-pc'),out=document.querySelector('.icl-pc__out');
  function money(a,c){var n=+a;try{return new Intl.NumberFormat(cc==='AU'?'en-AU':'en-NZ',{style:'currency',currency:c||cfg.currency||'NZD',minimumFractionDigits:n%1?2:0}).format(n);}catch(e){return '$'+n;}}
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
  function transit(txt){var m=/(\d+)\s*(?:-|–|to)\s*(\d+)\s*(?:business|working)?\s*days?/i.exec(txt||'');if(m)return[+m[1],+m[2]];
    m=/(\d+)\s*(?:business|working)\s*days?/i.exec(txt||'');return m?[+m[1],+m[1]]:null;}
  if(form&&out)form.addEventListener('submit',function(ev){
    ev.preventDefault();
    var b=active||boxes[0],e=entry(b),d=sizeBtn(b,b.size).dataset;
    var input=form.querySelector('input'),zip=(input.value||'').trim(),btn=form.querySelector('button');
    if((cc==='NZ'||cc==='AU')&&!/^\d{4}$/.test(zip)){out.innerHTML='<p class="icl-pc__err">Enter a 4-digit postcode.</p>';return;}
    if(!zip||!e)return;
    btn.disabled=true;out.setAttribute('data-key',b.id+':'+b.size+':'+b.colour);out.innerHTML='<p class="icl-pc__meta">Checking…</p>';
    var gql='mutation R($lines:[CartLineInput!]!,$cc:CountryCode!,$zip:String!) @inContext(country:$cc){cartCreate(input:{lines:$lines,delivery:{addresses:[{address:{deliveryAddress:{countryCode:$cc,zip:$zip}},selected:true,oneTimeUse:true}]}}){cart{deliveryGroups(first:3){nodes{deliveryOptions{title description estimatedCost{amount currencyCode}}}}}userErrors{message}}}';
    fetch(b.el.getAttribute('data-sf'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({query:gql,variables:{lines:[{merchandiseId:'gid://shopify/ProductVariant/'+e.variant,quantity:1}],cc:cc,zip:zip}})})
    .then(function(r){return r.json();}).then(function(j){
      var c=j&&j.data&&j.data.cartCreate&&j.data.cartCreate.cart,opts=[];
      (c&&c.deliveryGroups&&c.deliveryGroups.nodes||[]).forEach(function(g){(g.deliveryOptions||[]).forEach(function(o){opts.push(o);});});
      if(!opts.length){out.innerHTML='<p class="icl-pc__err">We couldn’t find a rate for '+esc(zip)+'. Check the postcode, or you’ll see every option at checkout.</p>';return;}
      opts.sort(function(a,b2){return +a.estimatedCost.amount - +b2.estimatedCost.amount;});
      var h='',best=opts[0];
      opts.forEach(function(o){h+='<div class="icl-pc__rate"><span>'+esc(o.title)+'</span><strong>'+money(o.estimatedCost.amount,o.estimatedCost.currencyCode)+'</strong></div>';});
      var tr=transit(best.title+' '+(best.description||'')),when;
      if(tr){when='Estimated delivery: '+fmt(addBiz(dMin,tr[0]))+' – '+fmt(addBiz(dMax,tr[1]));}
      else{when=dispatchTxt+'. Allow up to 7 working days after dispatch.';}
      out.innerHTML='<p class="icl-pc__meta">'+esc(d.label+' '+d.name+(b.colourName?' ('+b.colourName+')':''))+' to '+esc(zip)+', from our checkout:</p>'+h+'<p class="icl-pc__meta">'+esc(when)+'</p>';
      if(b.sub)b.sub.textContent=money(best.estimatedCost.amount,best.estimatedCost.currencyCode)+' to '+zip+' · '+(tr?when:dispatchTxt);
    }).catch(function(){out.innerHTML='<p class="icl-pc__err">We couldn’t check that just now. You’ll see every delivery option at checkout.</p>';})
    .then(function(){btn.disabled=false;});
  });

  /* expert drawer (same behaviour as the live Lennox Hastie PDP block) */
  var xo=document.getElementById('icx-expert-overlay');
  if(expertDr&&xo){
    document.body.appendChild(xo);document.body.appendChild(expertDr);
    var xclose=expertDr.querySelector('.icx-expert-drawer__close'),xform=expertDr.querySelector('.icx-expert-form'),xlast=null;
    var openX=function(from){xlast=from||null;expertDr.classList.add('is-open');xo.classList.add('is-open');document.documentElement.style.overflow='hidden';
      var first=expertDr.querySelector('input:not([type="hidden"]), .icx-expert-form__success');if(first)setTimeout(function(){first.focus();},400);};
    var closeX=function(){expertDr.classList.remove('is-open');xo.classList.remove('is-open');document.documentElement.style.overflow='';if(xlast)xlast.focus();};
    qa('.icx-expert__trigger').forEach(function(t){t.addEventListener('click',function(){openX(t);});});
    if(xclose)xclose.addEventListener('click',closeX);
    xo.addEventListener('click',closeX);
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&expertDr.classList.contains('is-open'))closeX();});
    if(document.getElementById('icx-expert-success')||(location.hash==='#icx-expert-form'&&expertDr.querySelector('.icx-expert-form__errors')))openX();
    if(xform&&xform.getAttribute('action')!=='#')xform.addEventListener('submit',function(ev){
      var g=function(id){return(document.getElementById(id)||{}).value||'';};
      var email=g('icx-expert-email'),name=g('icx-expert-name'),phone=g('icx-expert-phone'),msg=g('icx-expert-message');
      if(!email)return;
      ev.preventDefault();var btn=xform.querySelector('.icx-expert-form__submit');if(btn)btn.disabled=true;
      try{
        var k=window.klaviyo||(window.klaviyo=[]);var parts=name.trim().split(/\s+/);
        var id={'$email':email,'$first_name':parts[0]||'','$last_name':parts.slice(1).join(' ')};if(phone)id['$phone_number']=phone;
        k.push(['identify',id]);
        var b=active||boxes[0],e=entry(b)||{};
        k.push(['track','Requested Expert Consultation',{'Product Name':e.title||'','Variant':b.size+(b.colourName?' / '+b.colourName:''),'Price':+(e.amount||0),'Currency':cfg.currency||'',
          'Product URL':e.url?new URL(e.url,location.href).href:'','Message':msg,'Recipient':'sarah@ironcladpans.com','Source':'Guide page Expert Drawer '+location.pathname}]);
      }catch(err){}
      setTimeout(function(){xform.submit();},400);
    });
  }
})();
